import { SUPPORT_PHONE } from "./contact";

// Order lifecycle and reconciliation take precedence over a recorded payment.
export function orderPaymentBlock(order) {
  if (!order) return null;
  if (order.payment_reconciliation_required || order.reconciliation_required) {
    return { status: "review", message: "Pagamento da verificare con l’assistenza. Non effettuare un altro pagamento." };
  }
  if (["cancelled", "refunded", "archived"].includes(order.status) || order.archived === true || order.sub_status === "admin_cleanup_pre_pilot") {
    return { status: "closed", message: "Questa spedizione è annullata o archiviata. Un pagamento registrato non la riattiva. Contatta l’assistenza per verificarne lo stato." };
  }
  if ((order.delivery_type === "van" || order.package_size === "xl") && order.payment_status !== "paid") {
    return { status: "review", message: `Van su richiesta: il team deve verificare il collo, gli accessi e la movimentazione prima di prenotare o pagare. Contatta DapNow al ${SUPPORT_PHONE}.` };
  }
  if (order.delivery_type === "express" && order.payment_status !== "paid") {
    return { status: "review", message: `Express su richiesta: il team deve verificare tratta e disponibilità e confermare il servizio prima di prenotare o pagare. Contatta DapNow al ${SUPPORT_PHONE}.` };
  }
  return null;
}
